import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import SelectedTab from "../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader } from "reactstrap";
import {
  changeActiveTab,
  editDetailModal,
  setMode,
  showModal,
} from "../../../slices/agMember/agMemberSlice";
import Details from "./Details";
import { getAgMemberData } from "../AgMemberService";
import Family from "./Family";
import { useDispatch } from "react-redux";
import { openModal, resetFormState } from "../../../slices/common/reducer";
import { Button } from "react-bootstrap";
import ProfileModal from "../Modal/ProfileModal";
import "../AgMember.scss";
import EditPrimaryDetailsModal from "../Modal/EditPrimaryDetailsModal";
import { checkButtonAccess } from "../../../Utils/CommonUtils";

const SelectedAgMember = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.agMember.selectedAgMember.tabs);
  const activeTab = useSelector(
    (state) => state.agMember.selectedAgMember.activeTab
  );
  const navigator = useNavigate();
  const formState = useSelector((state) => state.common.formRendererState);
  const modalShow = useSelector((state) => state.common.modalShow);
  const agMemberData = useSelector((state) => state.agMember.agMemberData);
  const data = useSelector(
    (state) => state.agMember.selectedAgMember.detailsData
  );
  const editDetailShow = useSelector((state) => state.agMember.editDetailShow);
  const currentModal = useSelector((state) => state.agMember.currentModal);

  const openClickHandler = (e) => {
    e.preventDefault();
    // dispatch(openModal(true));
    navigator("/agmember/member/profile");
  };

  useEffect(() => {
    return () => {
      dispatch(resetFormState());
      dispatch(changeActiveTab("details"));
      dispatch(setMode("VIEW"));
    };
  }, [dispatch]);

  const breadcrumbItems = [
    { title: "AGM", link: "" },
    { title: "Members", link: "/agmember/member" },
    { title: `${data.code}`, link: "/agmember/member/update" },
  ];

  const [index, setIndex] = useState(-1);

  const handleEditClick = () => {
    dispatch(showModal("editDetails"));

    dispatch(editDetailModal(true));
  };

  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        {/* <div className="d-flex justify-content-end">
          <Button color="primary primary_button w-100" onClick={openClickHandler}>Profile</Button>
        </div> */}
        {/* <div className="details"> */}
        <Card className="details-wrapper">
          <CardHeader>
            <SelectedTab
              tabs={tabs}
              activeTab={activeTab}
              changeActiveTab={changeActiveTab}
              buttonEdit={true}
              label="Edit Credential"
              onEditClick={handleEditClick}
              checkAccessEdit={checkButtonAccess("EDIT_CREDENTIAL", "AGM_MEM")}
            />{" "}
          </CardHeader>
          {/* <CardBody> */}
          {/* <div className="selected-tab-bottom-content"> */}
          {activeTab === "details" && <Details />}
          {/* {activeTab === "family" && <Family />} */}
          {/* </div> */}
          {/* </CardBody> */}
        </Card>
      </div>
      {currentModal === "editDetails" && <EditPrimaryDetailsModal />}
      {/* </div> */}
    </>
  );
};

export default SelectedAgMember;
